import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import moment from 'moment';
import {Header, Page, PageMain, PageLeft, Input, Select, Row, Col} from 'routes/app/components';
import {Line as LineChart} from 'react-chartjs';
import {Bar as BarChart} from 'react-chartjs';
import ActualTrucks from './Chart/ActualTrucks';
import ActualOccupancy from './Chart/ActualOccupancy';
import AverageLeadTime from './Chart/AverageLeadTime';
import ActualLeadTime from './Chart/ActualLeadTime';
import RailStatusIn from './Pivot/RailStatusIn';
import RailStatusOut from './Pivot/RailStatusOut';
import './style.scss';
import {Link} from "react-router";
import Button from "../../app/components/Button";


const Dashboard = ({terminals, fields, actions, reports, isAllowed, isAuthenticated, ...other}) => {
    return (
        <section>
            <Header>
                <h1>Dashboard</h1>
                {!isAuthenticated &&
                    <Link
                        to="/login"
                        className="dashboard__login-btn"
                    >
                        <Button waves="light" className="btn-secondary">
                            <FormattedMessage id="auth.loginBtn" />
                        </Button>
                    </Link>
                }
            </Header>
            <Page className="dashboard-page">
                <Row>
                    <Col s={12} m={6} offset="m3">
                        {terminals.length > 1 &&
                        <Select s={12} id="dom" label="Terminal"
                                options={terminals} optionValue="code" optionLabel="name"
                                {...fields.dom}
                        />
                        }
                        {terminals.length === 1 &&
                        <Input s={12} label="Terminal" readOnly {...fields.dom} />
                        }
                    </Col>
                </Row>

                <Row>
                    {isAllowed(91910) && fields.dom.value &&
                    <Col s={12} m={6}>
                        <ActualTrucks rawData={reports.actualTrucks} fetch={actions.getActualTrucks} {...other} />
                    </Col>
                    }

                    {isAllowed(91911) && fields.dom.value &&
                    <Col s={12} m={6}>
                        <ActualLeadTime rawData={reports.actualLeadTime} fetch={actions.getActualLeadTime} {...other} />
                    </Col>
                    }

                    {isAllowed(91920) && fields.dom.value &&
                    <Col s={12} m={6}>
                        <ActualOccupancy rawData={reports.actualOccupancy} fetch={actions.getActualOccupancy}
                                         dateField={fields.date} {...other} />
                    </Col>
                    }
                    {isAllowed(91921) && fields.dom.value &&
                    <Col s={12} m={6}>
                        <AverageLeadTime rawData={reports.averageLeadTime} fetch={actions.getAverageLeadTime}
                                         dayOfWeekField={fields.dayOfWeek} {...other} />
                    </Col>
                    }
                </Row>

                {isAllowed(91922) && fields.dom.value &&
                <div>
                    <Row>
                        <Col s={12}>
                            <RailStatusIn rawData={reports.railStatusImport}
                                          fetch={actions.getRailStatusImport} {...other} />
                        </Col>
                    </Row>
                    <Row>
                        <Col s={12}>
                            <RailStatusOut rawData={reports.railStatusExport}
                                           fetch={actions.getRailStatusExport} {...other} />
                        </Col>
                    </Row>
                </div>}

                {/*<PageMain full>
                 <LineChart data={chartData} options={chartOptions} width="600" height="250" />
                 <BarChart data={chartData} options={chartOptions} width="600" height="250" />
                 </PageMain>*/}
            </Page>
        </section>
    );
};

Dashboard.propTypes = {
    terminals: PropTypes.array.isRequired,
    fields: PropTypes.object,
    isAllowed: PropTypes.func,
    actions: PropTypes.object,
    reports: PropTypes.object,
    isAuthenticated: PropTypes.bool.isRequired
};

export default Dashboard;
